import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const VersionElementFields = {
  group: ELEMENT_GROUPS.TEXT,
  label: 'Version Number',
  icon: 'DocumentTextIcon',
  description: 'Displays the current app version number',
  properties: [
    'layout',
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      description: 'The text to prepend to the field',
      default: 'Version #: ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default VersionElementFields;
